export const queries = {
  allFaqs: `
  query {
    allFaqs(where: { isActive: true }) {
      id
      heading
      subHeading
      isActive
      updatedAt
      legalApprovedDate
      category(where: { isActive: true }) {
        id
        name
        isActive
        queries(where: { isActive: true }) {
          id
          question
          answer
          isActive
        }
      }
    }
  }
`,
};
